import * as React from 'react';

import { WithLayoutPropsType } from 'components/hoc/withLayout';
import Card from 'containers/molecules/Card/Dashboard';
import { LayoutTriggers } from 'defs/layout';
import { TrackingDescriptionIDType } from 'defs/tracking';
import { itemTypes } from 'store/programItems';
import { WithRouterType } from 'types/withRouter';

export type DashboardNewMeasurementViewProps = WithRouterType &
	WithLayoutPropsType & {
		data: Object;
		currentWeight?: number;
		doRequestMeasurement: () => void;
		doAddEvents: (...events: Array<Object>) => void;
		doOpenDescription: (guideId: TrackingDescriptionIDType) => void;
	};

export class DashboardNewMeasurementView extends React.Component<DashboardNewMeasurementViewProps> {
	public static displayName = 'DashboardNewMeasurementView';

	public componentDidMount() {
		this.props.doRequestMeasurement();
		this.props.doLockBody(LayoutTriggers.NewMeasurementView);
	}

	public render() {
		const { history, data, currentWeight, doAddEvents, doOpenDescription } = this.props;

		return (
			<Card
				{...(data as any)}
				doOpenDescription={(guideId: TrackingDescriptionIDType) => doOpenDescription(guideId)}
				doAddEvents={(events) => doAddEvents(events)}
				currentWeight={currentWeight}
				type={itemTypes.TRACKING}
				history={history}
			/>
		);
	}
}

export default DashboardNewMeasurementView;
